import React, { useEffect, useState } from "react";
import { CustomLabel, HeaderDivider } from "../../../../../utilities/utll";
import { Col, Row } from "reactstrap";
import {
  Button,
  Checkbox,
  Collapse,
  Input,
  message,
  Select,
  Tooltip,
} from "antd";
import LuxuryCheckbox from "../../../../../common/Checkbox";
import { useBasicDataFormStore } from "../../../../../store/vendorRegistrationStore/useBasicDataFormStore";
import { apiRequest } from "../../../../../utilities/apiMethod";
import { useVendorMasterStore } from "../../../../../store/useVendorMasterStore";
import { CheckCircleFilled, QuestionCircleOutlined } from "@ant-design/icons";
import ApproveReject from "../../../../../components/approveReject/ApproveReject";
import { gstValidationApi } from "../../../../../services/vendorMaster";
import { useGenralInfoFormStore } from "../../../../../store/vendorRegistrationStore/useGeneralInfoFormStore";

export const BasicForm = () => {
  const { basicData, handleInputChange, errors, setErrors } =
    useBasicDataFormStore();
  const { state, getState, checkBoxes, setCheckbox, vendorDetailByGuid } =
    useVendorMasterStore();
  const showStep4 = localStorage.getItem("ShowStep4") === "Yes";
  const [localErrors, setLocalErrors] = useState({});
  const submitted = localStorage.getItem("submitted") === "Yes";
  const approve = localStorage.getItem("showApprove") === "true";
  const [country, setCountry] = useState([]);
  const [gstVerified, setGstVerified] = useState(false);
  const GUID = localStorage.getItem("vendorGUID") || "";
  const { formData } = useGenralInfoFormStore.getState();
  const adressOfgeneralInfo = formData.addresses[0];
  const { VendorType } = vendorDetailByGuid?.Vendor || {};

  useEffect(() => {
    fetchCountry();
  }, []);
  useEffect(() => {
    if (!submitted && GUID) handleInputChange("vendorGUID", GUID);
  }, [GUID]);

  useEffect(() => {
    if (submitted) return;
    if (!basicData.gstRegistration) {
      handleInputChange("gstRegistrationNumber", "");
      basicData.gstRegistration === null && handleInputChange("legalName", "");
      setErrors((prev) => ({
        ...prev,
        gstRegistrationNumber: "",
      }));
      setGstVerified(false);

      handleInputChange("pincode", adressOfgeneralInfo.pincode || "");
      handleInputChange("addressLine1", adressOfgeneralInfo.addressLine1 || "");
      handleInputChange("addressLine2", adressOfgeneralInfo.addressLine2 || "");
      handleInputChange("addressLine3", adressOfgeneralInfo.addressLine3 || "");
      handleInputChange("state", adressOfgeneralInfo.state || "");
    }
  }, [basicData.gstRegistration, adressOfgeneralInfo]);

  useEffect(() => {
    if (errors?.gstRegistrationNumber === undefined) {
      setGstVerified(true);
    }
    if (basicData?.gstRegistrationNumber === "") {
      setGstVerified(false);
    }
  }, [errors?.gstRegistrationNumber, basicData?.gstRegistrationNumber]);

  const fetchCountry = async () => {
    const val = await apiRequest("GET", "Country");
    if (
      val &&
      val.IsSuccess &&
      val.StatusCode === 200 &&
      Array.isArray(val.Data) &&
      val.Data.length > 0
    ) {
      val.Data.forEach((element, index) => {
        element.serialNo = index + 1;
      });
      setCountry(val.Data ?? []);
    } else {
      setCountry([]);
    }
  };
  const validateEmailAlternate = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setErrors({
        ...errors,
        alternateEmail: "Invalid Email Format",
      });
      return;
    }

    setErrors({ ...errors, alternateEmail: "" });
  };
  const validateEmail = (fieldName, value) => {
    if (!value) {
      setLocalErrors((prev) => ({ ...prev, [fieldName]: "" }));
      return;
    }

    const emails = value
      .split(";")
      .map((e) => e.trim())
      .filter(Boolean);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalid = emails.find((e) => !emailRegex.test(e));
    if (invalid) {
      setErrors({
        ...errors,
        email:
          "Invalid Email Format Or Multiple Emails should be separated by ; ",
      });
      return;
    }

    setErrors({ ...errors, email: "" });
  };

  const validateGstNumber = async (value) => {
    const gst = value.toUpperCase();
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

    if (gst && !gstRegex.test(gst)) {
      setErrors({
        ...errors,
        gstRegistrationNumber: "Invalid GST Number format",
      });
      return;
    }
    try {
      const response = await gstValidationApi(gst);
      const gstData = response?.Data?.AllData?.[0];
      // setGstData(gstData);

      if (
        gstData &&
        gstData.Status === "ACT"
        //  &&
        // gstData.BlkStatus === "U"
      ) {
        setErrors({
          ...errors,
          gstRegistrationNumber: "",
        });
        setGstVerified(true);
        await getState();
        const gstState = getStateFromGst(gstData);
        putGstDataToForm(gstData, gstState);
        handleInputChange(
          "legalName",
          gstData?.TradeName ? gstData?.TradeName : gstData?.LegalName,
        );
        message.success("GST Number is valid");
      } else {
        setErrors({
          ...errors,
          gstRegistrationNumber: "GST Number is not active or blocked",
        });
        setGstVerified(false);
        message.error("GST Number is not active or blocked");
      }
    } catch (error) {
      setErrors({
        ...errors,
        gstRegistrationNumber: "GST validation failed",
      });
      setGstVerified(false);
      message.error("GST validation failed");
    }
  };
  const normalizeStateCode = (code) => {
    if (code === null || code === undefined) return "";
    return String(code).padStart(2, "0");
  };
  const getStateFromGst = (gstData) => {
    if (!gstData || !state?.length) return null;

    const gstStateCode = normalizeStateCode(gstData?.StateCode);

    return state.find((s) => s.StateCode === gstStateCode) || null;
  };
  // const gstState = getStateFromGst();
  const putGstDataToForm = (gstData, gstState) => {
    if (!gstData) return;
    const addressLine1 = [gstData?.AddrBno, gstData?.AddrFlno, gstData?.AddrBnm]
      .filter(Boolean) // removes "", null, undefined
      .join(", ");
    handleInputChange("pincode", gstData?.AddrPncd || "");
    handleInputChange("addressLine1", addressLine1 || "");
    handleInputChange("addressLine2", gstData?.AddrSt || "");
    handleInputChange("addressLine3", gstData?.AddrLoc || "");
    handleInputChange("state", gstState.StateCode || "");
    handleInputChange("location", gstData?.AddrLoc || "");
  };

  const allChecked = Object.values(checkBoxes).every(Boolean);

  return (
    <>
      <HeaderDivider title="Tax Details" isShort />
      <Row style={{ marginTop: "20px" }}>
        <Col xl={3} md={6}>
          <CustomLabel children="Is GST Number Available" isImportnt />

          <Select
            placeholder="-- Select --"
            style={{ width: "100%" }}
            value={basicData.gstRegistration ?? undefined}
            disabled={submitted}
            onChange={(value) => {
              handleInputChange("gstRegistration", value);

              // clear GST number if NO selected
              if (!value) {
                handleInputChange("gstRegistrationNumber", "");
                setGstVerified(false);
              }
            }}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
          />
          {errors?.gstRegistration && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.gstRegistration}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginBottom: "2px",
            }}
          >
            <CustomLabel
              children={"GST Registration Number"}
              isImportnt={false}
              style={{
                marginBottom: 0,
                lineHeight: 1,
              }}
            />

            <div
              style={{ display: "flex", alignItems: "flex-start", gap: "2px" }}
            >
              <Button
                style={{
                  padding: 0,
                  height: "auto",
                  lineHeight: 1,
                }}
                size="small"
                type={gstVerified ? "primary" : "default"}
                icon={
                  gstVerified ? (
                    <CheckCircleFilled
                      style={{ color: "#52c41a", fontSize: 18 }}
                    />
                  ) : (
                    <CheckCircleFilled
                      style={{ color: "#d9d9d9", fontSize: 18 }}
                    />
                  )
                }
                // disabled={submitted || !basicData.gstRegistration}
                disabled
                onClick={() => setGstVerified((prev) => !prev)}
              />
            </div>
          </div>
          <Input
            type="text"
            placeholder="Enter GST Registration Number"
            size="medium"
            disabled={submitted || !basicData.gstRegistration}
            value={basicData.gstRegistrationNumber}
            onChange={(e) => {
              if (submitted) return;
              const value = e.target.value.toUpperCase();
              // const prefix = basicData.state;

              // // prevent editing first 2 digits
              // if (prefix && value.length >= 2 && !value.startsWith(prefix)) {
              //   return;
              // }

              // validateGstNumber(value);
              handleInputChange("gstRegistrationNumber", value);
            }}
            onBlur={(e) => validateGstNumber(e.target.value)}
          />

          {(localErrors.gstRegistrationNumber ||
            errors?.gstRegistrationNumber) && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {localErrors.gstRegistrationNumber ||
                errors?.gstRegistrationNumber}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Trade Name"} isImportnt={true} />
          <Input
            type="text"
            placeholder="Enter Trade Name"
            size="medium"
            value={basicData.legalName}
            onChange={(e) => handleInputChange("legalName", e.target.value)}
            disabled={submitted || basicData.gstRegistration === true}
          />
          {errors?.legalName && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.legalName}
            </span>
          )}
        </Col>
        {VendorType !== "ZAEX" && (
          <>
            {" "}
            <Col xl={3} md={6}>
              <CustomLabel children="Is FSSAI  Available" isImportnt />

              <Select
                placeholder="-- Select --"
                style={{ width: "100%" }}
                value={basicData.fssaiRegistration ?? undefined}
                disabled={submitted}
                onChange={(value) => {
                  handleInputChange("fssaiRegistration", value);

                  // clear Fssai number if NO selected
                  if (!value) {
                    handleInputChange("fssaiRegistrationNumber", "");
                  }
                }}
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
              />
              {errors?.fssaiRegistration && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {errors?.fssaiRegistration}
                </span>
              )}
            </Col>
            <Col xl={3} lg={3} md={6} sm={12}>
              <CustomLabel children={"FSSAI"} isImportnt={false} />
              <Input
                type="text"
                placeholder="Enter FSSAI"
                size="medium"
                value={basicData.fssaiRegistrationNumber}
                onChange={(e) =>
                  handleInputChange("fssaiRegistrationNumber", e.target.value)
                }
                disabled={submitted || !basicData.fssaiRegistration}
              />
              {errors?.fssaiRegistrationNumber && (
                <span style={{ color: "red", fontSize: "12px" }}>
                  {errors?.fssaiRegistrationNumber}
                </span>
              )}
            </Col>
          </>
        )}
      </Row>
      <Row>
        <Col xl={3} md={6}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "4px",
            }}
          >
            <CustomLabel children="Is MSME Registered" isImportnt />
          </div>

          <Select
            placeholder="-- Select --"
            style={{ width: "100%" }}
            value={basicData.msmeRegistration ?? undefined}
            disabled={submitted}
            onChange={(value) => {
              handleInputChange("msmeRegistration", value);

              if (!value) {
                handleInputChange("msmeRegistrationNumber", "");
              }
            }}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
          />
          {errors?.msmeRegistration && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.msmeRegistration}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              alignItems: "flex-end",
              marginBottom: "2px",
            }}
          >
            <CustomLabel
              style={{
                marginBottom: 0,
                lineHeight: 1,
              }}
              children={"MSME Number"}
              isImportnt={false}
            />
          </div>
          <Input
            type="text"
            placeholder="Enter MSME Number"
            size="medium"
            disabled={submitted || !basicData.msmeRegistration}
            value={basicData.msmeRegistrationNumber}
            onChange={(e) =>
              handleInputChange("msmeRegistrationNumber", e.target.value)
            }
          />
          {errors?.msmeRegistrationNumber && (
            <span style={{ color: "red", fontSize: "12px" }}>
              {errors?.msmeRegistrationNumber}
            </span>
          )}
        </Col>
        <Col xl={3} lg={3} md={6} sm={12}>
          <CustomLabel children={"Other"} isImportnt={false} />
          <Input
            type="text"
            placeholder="Enter Other"
            size="medium"
            value={basicData.other}
            onChange={(e) => handleInputChange("other", e.target.value)}
            disabled={submitted}
          />
        </Col>
        {submitted && showStep4 && (
          <Col
            xl={3}
            lg={3}
            md={6}
            sm={12}
            style={{
              marginTop: 20,
            }}
          >
            <LuxuryCheckbox
              id={"taxDetails"}
              label="Checked"
              checked={checkBoxes.taxDetails}
              onChange={(e) =>
                setCheckbox("taxDetails", !checkBoxes.taxDetails)
              }
              disabled={!approve}
            />
          </Col>
        )}
      </Row>

      {/* <HeaderDivider title="Address" isShort /> */}
      <Collapse
        defaultActiveKey={[]}
        items={[
          {
            key: "1",
            label: "Address",
            children: (
              <>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={3} md={6}>
                    <CustomLabel
                      children={"Vendor Country"}
                      isImportnt={true}
                    />
                    <Select
                      placeholder="Select Country"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={country?.map((item) => ({
                        label: item.CountryName,
                        value: item.CountryCode,
                      }))}
                      onChange={(value) => {
                        handleInputChange("country", value);
                        getState(value);
                      }}
                      value={basicData.country}
                      disabled={submitted || basicData.gstRegistration}
                    />
                    {errors?.country && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.country}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} md={6}>
                    {" "}
                    <CustomLabel children={"State"} isImportnt={true} />{" "}
                    <Select
                      placeholder="Select State"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      size="medium"
                      style={{ width: "100%" }}
                      options={state?.map((item) => ({
                        label: item.StateName,
                        value: item.StateCode,
                      }))}
                      onChange={(value) => {
                        handleInputChange("state", value);
                      }}
                      value={basicData.state}
                      disabled={submitted || basicData.gstRegistration}
                    />{" "}
                    {errors?.state && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {" "}
                        {errors?.state}{" "}
                      </span>
                    )}{" "}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel children={"City"} isImportnt={true} />
                    <Input
                      type="text"
                      placeholder="Enter City"
                      size="medium"
                      value={basicData.city}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only letters and spaces
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          handleInputChange("city", value);
                        }
                      }}
                      disabled={submitted}
                    />
                    {errors?.city && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.city}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel children={"Pin Code"} isImportnt={true} />
                    <Input
                      type="number"
                      placeholder="Enter Pin Code"
                      size="medium"
                      value={basicData.pincode}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only digits, no negatives, no decimals
                        if (/^\d*$/.test(value) && value.length <= 6) {
                          handleInputChange("pincode", e.target.value);
                        }
                      }}
                      disabled={submitted || basicData.gstRegistration}
                    />
                    {errors?.pincode && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.pincode}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel
                      children={"Address line 1"}
                      isImportnt={true}
                    />
                    <Input.TextArea
                      id="address"
                      placeholder="Enter address 1"
                      rows={3}
                      value={basicData.addressLine1}
                      onChange={(e) =>
                        handleInputChange("addressLine1", e.target.value)
                      }
                      disabled={submitted || basicData.gstRegistration}
                    />
                    {errors?.addressLine1 && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.addressLine1}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6}>
                    <CustomLabel
                      children={"Address line 2"}
                      isImportnt={true}
                    />
                    <Input.TextArea
                      id="address"
                      placeholder="Enter address 2"
                      rows={3}
                      value={basicData.addressLine2}
                      onChange={(e) =>
                        handleInputChange("addressLine2", e.target.value)
                      }
                      disabled={submitted || basicData.gstRegistration}
                    />
                    {errors?.addressLine2 && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.addressLine2}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={12}>
                    <CustomLabel
                      children={"Address line 3"}
                      isImportnt={true}
                    />
                    <Input.TextArea
                      id="address"
                      placeholder="Enter address 3"
                      rows={3}
                      value={basicData.addressLine3}
                      onChange={(e) =>
                        handleInputChange("addressLine3", e.target.value)
                      }
                      disabled={submitted || basicData.gstRegistration}
                    />
                    {errors?.addressLine3 && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.addressLine3}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={12}>
                    <CustomLabel children={"Address line 4"} />
                    <Input.TextArea
                      id="address"
                      placeholder="Enter address 4"
                      rows={3}
                      value={basicData.addressLine4}
                      onChange={(e) =>
                        handleInputChange("addressLine4", e.target.value)
                      }
                      disabled={submitted}
                    />
                    {errors?.addressLine4 && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.addressLine4}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel children={"Location"} isImportnt={true} />
                    <Input
                      type="text"
                      placeholder="Enter Location"
                      size="medium"
                      value={basicData.location}
                      onChange={(e) =>
                        handleInputChange("location", e.target.value)
                      }
                      disabled={submitted}
                    />
                    {errors?.location && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.location}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"First Name (Contact)"}
                      isImportnt={true}
                    />
                    <Input
                      type="text"
                      placeholder="Enter First Name (Contact)"
                      size="medium"
                      value={basicData.contactPersonFirstName}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only letters and spaces
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          handleInputChange("contactPersonFirstName", value);
                        }
                      }}
                      disabled={submitted}
                    />
                    {errors?.contactPersonFirstName && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.contactPersonFirstName}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Last Name (Contact)"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Last Name (Contact)"
                      size="medium"
                      value={basicData.contactPersonLastName}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only letters and spaces
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          handleInputChange("contactPersonLastName", value);
                        }
                      }}
                      disabled={submitted}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        marginBottom: "2px",
                      }}
                    >
                      <CustomLabel
                        style={{
                          marginBottom: 0,
                          lineHeight: 1,
                        }}
                        children={"Email (Contact)"}
                        isImportnt={true}
                      />

                      {/* <span title="You can enter multiple email addresses separated by commas"> */}
                      <Tooltip title="You can enter multiple email addresses separated by Semicolon (;)">
                        <span style={{ marginLeft: "10px" }}>
                          <Button
                            style={{
                              padding: 0,
                              height: "auto",
                              lineHeight: 1,
                            }}
                            icon={<QuestionCircleOutlined />}
                            size="small"
                          />
                        </span>
                      </Tooltip>
                      {/* </span> */}
                    </div>
                    <Input
                      type="text"
                      placeholder="Enter Email"
                      size="medium"
                      value={basicData.email}
                      onChange={(e) => {
                        handleInputChange("email", e.target.value);
                      }}
                      onBlur={(e) => validateEmail("email", e.target.value)}
                      disabled={submitted}
                    />
                    {(localErrors.email || errors.email) && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {localErrors.email || errors.email}
                      </span>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Contact Number"}
                      isImportnt={true}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Contact Number"
                      size="medium"
                      value={basicData.contactNumber}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only digits, max 10 digits
                        if (/^\d{0,10}$/.test(value)) {
                          handleInputChange("contactNumber", value);
                        }
                      }}
                      disabled={submitted}
                    />
                    {errors?.contactNumber && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors?.contactNumber}
                      </span>
                    )}
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Alternate Contact Person name"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Name"
                      size="medium"
                      value={basicData.alternateContactPersonName}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only letters and spaces
                        if (/^[A-Za-z\s]*$/.test(value)) {
                          handleInputChange(
                            "alternateContactPersonName",
                            value,
                          );
                        }
                      }}
                      // onChange={(e) =>
                      //   handleInputChange("alternateContactPersonName", e.target.value)
                      // }
                      disabled={submitted}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Alternate Contact Number"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Alternate Contact Number"
                      size="medium"
                      value={basicData.alternateContactNumber}
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only digits, max 10 digits
                        if (/^\d{0,10}$/.test(value)) {
                          handleInputChange("alternateContactNumber", value);
                        }
                      }}
                      disabled={submitted}
                    />
                  </Col>
                  <Col xl={3} lg={3} md={6} sm={12}>
                    <CustomLabel
                      children={"Email (Alternate)"}
                      isImportnt={false}
                    />
                    <Input
                      type="text"
                      placeholder="Enter Email"
                      size="medium"
                      value={basicData.alternateEmail}
                      onChange={(e) => {
                        handleInputChange("alternateEmail", e.target.value);
                      }}
                      onBlur={(e) => validateEmailAlternate(e.target.value)}
                      disabled={submitted}
                    />
                    {errors.alternateEmail && (
                      <span style={{ color: "red", fontSize: "12px" }}>
                        {errors.alternateEmail}
                      </span>
                    )}
                  </Col>
                  {submitted && showStep4 && (
                    <Col
                      xl={2}
                      lg={2}
                      md={6}
                      sm={12}
                      style={{
                        marginBottom: 0,
                        paddingBottom: 0,
                        paddingTop: 0,
                        lineHeight: 1,
                      }}
                    >
                      <LuxuryCheckbox
                        id={"address"}
                        label="Checked"
                        checked={checkBoxes.address}
                        onChange={(e) =>
                          setCheckbox("address", !checkBoxes.address)
                        }
                        disabled={!approve}
                      />
                    </Col>
                  )}
                </Row>
              </>
            ),
          },
        ]}
      />
      {submitted && approve && <ApproveReject checked={allChecked} />}
    </>
  );
};
